export const CentersList = [
    // {
    //     id: 1,
    //     header: "Head Office",
    //     contactPerson: "Prabhjot singh",
    //     address: `First Floor, Office no -3, 
    //     CMS Complex, Sector-5 Chowk, 
    //     Ashok Vihar, Phase - II, 
    //     Gurgaon, Haryana - 122001`,
    //     email: "info@jlgv.in",
    //     contactNumber: '+ 91 - 9910041377/9315499907',
    //     src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.794718674052!2d77.01428688447169!3d28.485728213206055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19dcf6954ea3%3A0x72cf28de8e9ea5ad!2sCMS%20Complex%2C%20Carterpuri%20Rd%2C%20Ashok%20Vihar%2C%20Ashok%20Vihar%20Phase%20II%2C%20Gurugram%2C%20Haryana%20122006!5e0!3m2!1sen!2sin!4v1753810106749!5m2!1sen!2sin"
    // },
    
    {
        id: 1,
        header: "Test Center",
        contactPerson: "Prabhjot singh",
        address: `TA-03, 3rd Floor, Crown Plaza Mall,
        Sector- 15A, Faridabad, Haryana, 121007`,
        email: "lokeshloomba@jlgv.in",
        contactNumber: '+91 9910041377',
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.708314240392!2d77.31042857580358!3d28.397876675793828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdc4bcfb1d055%3A0xe25d9d960d7d984a!2sCrown%20Plaza!5e0!3m2!1sen!2sin!4v1753378587919!5m2!1sen!2sin"
    },
    {
        id: 2,
        header: "Operations Office",
        contactPerson: "Prabhjot singh",
        address: `C-830, 8th Floor, Vipul Plaza,
        Sector 81, Faridabad -121002`,
        email: "info@jlgv.in",
        contactNumber: '+91 9560207200',
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3510.0139151315398!2d77.34626927580332!3d28.388647675798865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdcf040000001%3A0xa6afbffbc2ddd890!2sVipul%20Plaza!5e0!3m2!1sen!2sin!4v1753810171723!5m2!1sen!2sin"
    },
]

// 17: 11
// ייון ייו
// 6
// 37
// jlgv.in
// Registered Office:
// First Floor, Office no - 3, CMS Complex, Sector - 5 Chowk, Ashok Vihar, Phase - II, Gurgaon, Haryana - 122001
//     + 91 - 9910041377 / 9315499907
// info @jlgv.in
// Operations Office Address:
// C - 830, 8th Floor, Vipul Plaza, Sector 81, Faridabad - 121002
//     + 91 - 9910041377 / 9315499907
// info @jlgv.in
// Test Center Address:
// TA-03, Third Floor, Crown Plaza Mall, Sector 15 - A Faridabad, Haryana, 121001
//     + 91 - 9910041377
// lokeshloomba @jlgv.in
// First name *